import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles((theme) => ({
  tableContainer: {
    maxHeight: 500,
    minHeight: 110,
    "& .MuiTable-root":{
      paddingBottom: theme.spacing(0),
    },
    "&:last-child": {
      borderBottom: "none !important",
    },
    borderRadius: 8,
    borderRight: "0px !important"
  },
  tableHeader: {
    height: 60,
  },
  headerCell: {
    height: 70,
    fontSize: 14,
    fontWeight: 600,
    padding: theme.spacing(1),
    color: theme.palette.text.dark,
    backgroundColor: theme.palette.Other.background,
    boxShadow: "inset -1px -1px 0px #5A404E",
    "&:first-child": {
      paddingLeft: theme.spacing(4),
    },
    "&:last-child": {
      paddingRight: theme.spacing(4),
    },
  },
  tableDataRow: {
    height: 65,
    backgroundColor: theme.palette.Primary.contrastText,
    boxShadow: "inset 0px -1px 0px rgba(80, 80, 80, 0.15)",
    "&:hover": {
      backgroundColor: "#EFEFEF",
    },
    "&:last-child": {
      boxShadow: "none !important",
    },
  },
  selectableTableRow: {
    cursor: "pointer",
  },
  tableSelectedRow: {
    backgroundColor: theme.palette.Primary.background,
    "&:hover": {
      backgroundColor: "#FFDED2", // TODO: add to the theme once it is available
    },
  },
  tableBodyCell: {
    fontSize: 14,
    fontWeight: 400,
    padding: theme.spacing(1),
    textTransform: "capitalize",
    boxShadow: "inset -1px -1px 0px  #5A404E",
    "&:first-child": {
      paddingLeft: theme.spacing(4),
    },
    "&:last-child": {
      paddingRight: theme.spacing(4),
    },
  },
  progress: {
    color: theme.palette.Warning.main,
  },
  footerCell: {
    textAlign: "center",
    padding: theme.spacing(3),
    boxShadow: "inset 0px -1px 0px rgba(80, 80, 80, 0.15)",
  },
  tableFooter: {
    height: 52,
    backgroundColor: theme.palette.Primary.contrastText,
  },
  noDataWarning: {
    position: "absolute",
    textAlign: "center",
    width: "75%",
  },
  approved: {
    width: "16px !important", height: "16px !important", borderRadius: '50%',
    display:"inline-block",
    border: "1px solid black",
    backgroundColor: "#48742C",
    fontWeight:500,
    fontSize: 14
  },
  review: {
    width: "16px !important", height: "16px !important", borderRadius: '50%',
    display:"inline-block",
    border: "1px solid black",
    backgroundColor: "#D3291D",
    fontWeight:500,
    fontSize: 14
  },
  verified: {
    width: "16px !important", height: "16px !important", borderRadius: '50%',
    display:"inline-block",
    border: "1px solid black",
    backgroundColor: theme.palette.status.verified,
    fontWeight:500,
    fontSize: 14
  },
  audited: {
    width: "16px !important", height: "16px !important", borderRadius: '50%',
    display:"inline-block",
    border: "1px solid black",
    backgroundColor: "#024FE4",
    fontWeight:500,
    fontSize: 14
  },
  'pending-approval': {
    width: "16px !important", height: "16px !important", borderRadius: '50%',
    display:"inline-block",
    border: "1px solid black",
    backgroundColor: "#F7931D",
    fontWeight:500,
    fontSize: 14
  },
  'in-progress': {
    width: "16px !important", height: "16px !important", borderRadius: '50%',
    display:"inline-block",
    border: "1px solid black",
    backgroundColor: "#F7931D",
    fontWeight:500,
    fontSize: 14,
  },
  added:{
    width: "16px !important", height: "16px !important", borderRadius: '50%',
    display:"inline-block",
    border: "1px solid black",
    backgroundColor: "#7B7B7B",
    fontWeight:500,
    fontSize: 14
  },
  pending :{
    width: "16px !important", height: "16px !important", borderRadius: '50%',
    display:"inline-block",
    border: "1px solid black",
    backgroundColor: 'red',
    fontWeight:500,
    fontSize: 14
  },
  awaiting :{
    width: "16px !important", height: "16px !important", borderRadius: '50%',
    display:"inline-block",
    border: "1px solid black",
    backgroundColor: '#F5C142',
    fontWeight:500,
    fontSize: 14
  },
  default:{
    width: "16px !important", height: "16px !important", borderRadius: '50%',
    display:"inline-block",
    border: "1px solid black",
    backgroundColor: "black",
    fontWeight:500,
    fontSize: 14
  }
}));
export default useStyles;
